import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-appv-range',
  templateUrl: './appv-range.component.html',
  styleUrls: [],
  standalone: false
})
export class APPaymentRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
